import React from "react";

import { withStyles } from '@mui/styles';
import { Button, FormControlLabel, Radio, RadioGroup } from '@mui/material';

import ComponentWrapper from "../common/ComponentWrapper";
import CommonStyles from "../common/CommonStyles";
import LoaderNew from "../common/LoaderNew";

const styles = {
  frmControlLabel: {
    width: 'fit-content',
    marginLeft: '-10px',
  },
  insetShadowInput: {
    backgroundColor: '#F5F5F5',
    boxShadow: 'inset 0px 1px 1px #D6D6D6',
    width: '350px',
    maxWidth: '500px',
    border: 'none',
    '&:focus': {
      outline: '1px solid #70b8ff'
    },
  },
  okBtn: {
    height: '30px',
    padding: '5px 30px',
    minWidth: '140px',
    backgroundColor: '#222029',
    borderRadius: '15px',
    color: 'white',
    opacity: '0.8',
    '&:hover': {
      opacity: '1.0',
      backgroundColor: '#222029',
    },
  },
  ...CommonStyles,
};

const unsubscribeOptions = {
  1: "I never subscribed to this newsletter",
  2: "I am no longer interested in receiving these emails",
  3: "I am receiving too many emails",
  4: "The content is irrelevant",
  5: "I don't recognize the sender or organization",
  6: "Other (please, specify)",
};

class UnsubscribePage extends ComponentWrapper {
  state = {
    hash: '',
    status: null,
    senderEmail: '',
    isHashBroken: false,
    resubscribed: false,
    unsubscribed: false,
    whyUnsubscribe: '',
    textOtherFieldValue: '',
  };

  componentDidMount = () => {
    document.title="Unsubscribe | Milkyweb";
    document.body.style.backgroundColor = '#fff';

    const currentUrl = window.location.href;
    const hash = currentUrl.split('/unsubscribe/')[1];

    this.setState({ hash }, () => {
      this.getHashData();
    });
  };

  getHashData = () => {
    this.get({
      url: `/rest/check_email_subscription/${this.state.hash}`,
      cb: (res) => {
        if (res && res._status === 'ok') {
          const senderEmail = res.data.sender_email;
          const status = res.data.status;
          const unsubscribed = status === 1;

          this.setState({ unsubscribed, senderEmail, status });
        } else this.setState({ isHashBroken: true });
      },
      errorCb: () => this.setState({ isHashBroken: true }),
    })
  };

  handleTextFieldChange = (value) => {
    this.setState({ textOtherFieldValue: value });
  };

  submitUnsubscribeData = () => {
    const { hash, whyUnsubscribe, textOtherFieldValue } = this.state;

    const text = whyUnsubscribe === '6' ? textOtherFieldValue : unsubscribeOptions[whyUnsubscribe];
    const option = whyUnsubscribe === '6' ? 0 : +whyUnsubscribe;

    const reqData = {
      hash,
      option,
      text,
    };

    this.postWithData({
      url: `/rest/unsubscribe_from_mailing`,
      data: reqData,
      cb: (res) => {
        if (res && res._status === 'ok') {
          this.setState({ unsubscribed: true });
        }
        this.setState({ loading: false });
      },
      errorCb: () => {
        this.setState({ loading: false });
      }
    });
  };

  submitSubscribeData = () => {
    const { hash } = this.state;

    this.postWithData({
      url: `/rest/subscribe_to_mailing`,
      data: {
        hash
      },
      cb: (res) => {
        if (res && res._status === 'ok') {
          this.setState({ resubscribed: true });
        }
        this.setState({ loading: false });
      },
      errorCb: () => {
        this.setState({ loading: false });
      }
    });
  };

  render () {
    const { classes } = this.props;
    const { loading, isHashBroken, senderEmail, resubscribed, unsubscribed, whyUnsubscribe, textOtherFieldValue } = this.state;

    return (
      <div className={`${classes.alignCenter} ${classes.mt30}`} style={{ width: '800px', marginLeft: '100px' }}>
        {isHashBroken ?
          <div className={`${classes.alignStartColumn}`}>
            <h2 className={`${classes.alignCenter} ${classes.ml10}`}><span style={{ fontSize: 22 }}>😵</span> &nbsp; Oops! The link you followed seems to be broken</h2>
            <span className={`${classes.mt20} ${classes.ml10}`} style={{ fontSize: 14 }}>We recommend trying to access it from the original source</span>
          </div>
        :
        <React.Fragment>
          {resubscribed ?
            <div className={`${classes.alignStartColumn}`}>
              <h2 className={`${classes.alignCenter} ${classes.ml10}`}><span style={{ fontSize: 22 }}>🤗</span> &nbsp; Happy to see you back!</h2>
              <span className={`${classes.mt20} ${classes.ml10}`} style={{ fontSize: 14 }}>You have been successfully joined to the&nbsp;<strong>{senderEmail}</strong>&nbsp;mailing list</span>
            </div>
          : unsubscribed ?
            <div className={`${classes.alignStartColumn}`}>
              <h2 className={`${classes.alignCenter} ${classes.ml10}`}><span style={{ fontSize: 22 }}>🤫</span> &nbsp; You have been removed from the mailing list</h2>
              <span className={`${classes.mt20} ${classes.ml10}`} style={{ fontSize: 14 }}>If it was a mistake, please click the button below to resubscribe to&nbsp;<strong>{senderEmail}</strong>&nbsp;</span>
              <div className={`${classes.p10}`}>
                <Button
                  disableElevation
                  size="small"
                  variant="contained"
                  className={`${classes.okBtn} ${classes.mt20}`}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ loading: true }, () => {
                      this.submitSubscribeData();
                    })
                  }}>
                  {loading ? <LoaderNew color='white'/> : 'Subscribe'}
                </Button>
              </div>
            </div>
            :
            <div className={`${classes.alignStartColumn}`}>
              <h2 className={`${classes.alignCenter} ${classes.ml10}`}><span style={{ fontSize: 22 }}>😔</span> &nbsp; Sorry to see you leave!</h2>
              <span className={`${classes.mt20} ${classes.ml10}`} style={{ fontSize: 14 }}>Please, tell us why you unsubscribe from&nbsp;<strong>{senderEmail}</strong></span>
              <div className={`${classes.p10}`}>
                <RadioGroup
                  value={whyUnsubscribe}
                  onChange={(e) => console.log(e.target.value)}
                >
                  {Object.values(unsubscribeOptions).map((optionVal, index) => {
                    const optionKey = Object.keys(unsubscribeOptions).find(key => unsubscribeOptions[key] === optionVal);

                    return (
                      <FormControlLabel
                        key={index}
                        className={classes.frmControlLabel}
                        value={optionKey}
                        control={
                          <Radio
                            onChange={(e) => this.setState({ whyUnsubscribe: e.target.value })}
                          />
                        }
                        label={optionVal}
                      />
                    )
                  })}

                  <div className={classes.alignCenter}>
                    <textarea
                      rows={5}
                      value={textOtherFieldValue}
                      className={`${classes.insetShadowInput}`}
                      onChange={(e) => {
                        console.log(e.target.value)
                        this.handleTextFieldChange(e.target.value)
                      }}
                    />
                  </div>
                </RadioGroup>
                <Button
                  disabled={whyUnsubscribe === ''}
                  disableElevation
                  size="small"
                  variant="contained"
                  className={`${classes.okBtn} ${classes.mt20}`}
                  onClick={(e) => {
                    e.preventDefault();
                    this.setState({ loading: true }, () => {
                      this.submitUnsubscribeData();
                    })
                  }}>
                  {loading ? <LoaderNew color='white'/> : 'Unsubscribe'}
                </Button>
              </div>
            </div>
          }
        </React.Fragment>
        }
      </div>
    )
  }
};

export default withStyles(styles)(UnsubscribePage);
